import QuestionInstanceForm from './QuestionInstanceForm';

export default QuestionInstanceForm;
